import { render, staticRenderFns } from "./DoughnutWrapper.vue?vue&type=template&id=47914f3e"
import script from "./DoughnutWrapper.vue?vue&type=script&lang=js"
export * from "./DoughnutWrapper.vue?vue&type=script&lang=js"
import style0 from "./DoughnutWrapper.vue?vue&type=style&index=0&id=47914f3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports